import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { getYoutubeEmbedUrl } from "@/lib/youtube";
import { Guide } from "@/api/guides";

interface GuideVideoModalProps {
  guide: Guide | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const GuideVideoModal: React.FC<GuideVideoModalProps> = ({
  guide,
  open,
  onOpenChange,
}) => {
  const { t } = useTranslation();
  const embedUrl = guide ? getYoutubeEmbedUrl(guide.link) : null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-2xl p-0 overflow-hidden">
        <DialogHeader className="px-6 pt-6">
          <DialogTitle>{guide?.title}</DialogTitle>
        </DialogHeader>
        <div className="aspect-video w-full bg-black">
          {embedUrl ? (
            <iframe
              className="h-full w-full"
              src={embedUrl}
              title={guide?.title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <div className="flex h-full items-center justify-center p-6 text-sm text-muted-foreground">
              {t("guides.video_error", { defaultValue: "Impossible de charger la vidéo, veuillez réessayer plus tard." })}
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
